import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@web/components/ui/accordion';

import { ContactCommentList } from './comment-list';
import { ContactContracts } from './contact-contracts';
import { ContactInfo } from './contact-info';
import { ContactInterests } from './contact-interests';
import { ContactPayments } from './contact-payments';
import { Route } from '@web/routes/dashboard/route';

export function ContactData({ contactId }: { contactId: string }) {
  const { setActiveCommentId } = Route.useRouteContext();

  return (
    <div className="flex flex-col">
      <Accordion
        type="single"
        defaultValue="contracts"
        collapsible
        className="border-none"
      >
        <AccordionItem value="info">
          <AccordionTrigger className="py-3 transition-colors hover:bg-gray-50/80">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary/70 mr-2 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
              <h3 className="text-base font-medium">Contact Info</h3>
            </div>
          </AccordionTrigger>

          <AccordionContent className="px-3 pb-5 pt-3">
            <ContactInfo key={contactId} contactId={contactId} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="contracts">
          <AccordionTrigger className="py-3 transition-colors hover:bg-gray-50/80">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary/70 mr-2 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <h3 className="text-base font-medium">Contracts</h3>
            </div>
          </AccordionTrigger>

          <AccordionContent className="px-3 pb-5 pt-3">
            <ContactContracts contactId={contactId} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="payments">
          <AccordionTrigger className="py-3 transition-colors hover:bg-gray-50/80">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary/70 mr-2 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              <h3 className="text-base font-medium">Payments</h3>
            </div>
          </AccordionTrigger>

          <AccordionContent className="px-3 pb-5 pt-3">
            <ContactPayments contactId={contactId} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="interests">
          <AccordionTrigger className="py-3 transition-colors hover:bg-gray-50/80">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary/70 mr-2 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                />
              </svg>
              <h3 className="text-base font-medium">Interests</h3>
            </div>
          </AccordionTrigger>

          <AccordionContent className="px-3 pb-5 pt-3">
            <ContactInterests contactId={contactId} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="comments">
          <AccordionTrigger className="py-3 transition-colors hover:bg-gray-50/80">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary/70 mr-2 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                />
              </svg>
              <h3 className="text-base font-medium">Comments</h3>
            </div>
          </AccordionTrigger>

          <AccordionContent className="px-3 pb-5 pt-3">
            <ContactCommentList
              contactId={contactId}
              setActiveCommentId={setActiveCommentId}
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
